var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.071 10.0179C16.071 12.8631 13.8003 15.1695 10.9995 15.1695C8.19858 15.1695 5.92773 12.8631 5.92773 10.0179C5.92773 7.1728 8.19841 4.86621 10.9995 4.86621C13.8005 4.86621 16.071 7.1728 16.071 10.0179Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6347 10.0169C21.6347 12.695 20.4994 14.8669 19.0988 14.8669C17.6983 14.8669 16.563 12.695 16.563 10.0169C16.563 7.33886 17.6982 5.16699 19.0987 5.16699C20.4992 5.16699 21.6345 7.33817 21.6345 10.0169",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9105 10.0186C23.9105 12.4175 23.5113 14.3634 23.0186 14.3634C22.526 14.3634 22.127 12.418 22.127 10.0186C22.127 7.61919 22.5262 5.67383 23.0186 5.67383C23.5111 5.67383 23.9105 7.61902 23.9105 10.0186Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.d475763f0dd30a8bf451383608f26b87.svg";
export { ForwardRef as ReactComponent };